import { Grid } from '@mui/material'
import React from 'react'
import TransformDisplayToEdition from '../../../../components/form/TransformDisplayToEdition'
import { FieldsProps } from '.'
import { useFormikContext } from 'formik'
import { displayDateAsText } from '../../../../utils/displayDateAsText'
import dayjs from 'dayjs'
import { AdgroupExtendedSettingsFormInterface } from '../Settings'
import { useUserPermissions } from '../../../company/userPermissions'
import { ADGROUP_FLIGHT_DATE_FORMAT } from './adgroupFlightDateFormat'
import { FieldGroup, fieldGroupItemSize } from './FieldGroup'

const Dates: React.FC<FieldsProps> = ({
  adgroup,
  isWizard = false,
  canEdit = true,
  fullWidth = false,
  allowUnchanged = false,
}): JSX.Element => {
  const {
    values: { startDate },
  } = useFormikContext<AdgroupExtendedSettingsFormInterface>()
  const { adgroupDatesRequired } = useUserPermissions()

  const datesRequired = !allowUnchanged && adgroupDatesRequired
  const datesClearable = allowUnchanged || !adgroupDatesRequired

  return (
    <FieldGroup size={fullWidth ? 12 : 3}>
      <Grid size={fieldGroupItemSize}>
        <TransformDisplayToEdition
          inputType="datepicker"
          name="startDate"
          label="commons.startDate"
          text={displayDateAsText(adgroup.startDate, ADGROUP_FLIGHT_DATE_FORMAT)}
          InputLabelProps={{
            disableAnimation: true,
            shrink: true,
          }}
          tooltipText="adgroup.budgetAndDates.dateHelper"
          clearable={datesClearable}
          required={datesRequired}
          disableHoverEdition={isWizard}
          editable={canEdit}
        />
      </Grid>
      <Grid size={fieldGroupItemSize}>
        <TransformDisplayToEdition
          inputType="datepicker"
          minDate={startDate ? dayjs(startDate) : undefined}
          name="endDate"
          label="commons.endDate"
          text={displayDateAsText(adgroup.endDate, ADGROUP_FLIGHT_DATE_FORMAT)}
          InputLabelProps={{
            disableAnimation: true,
            shrink: true,
          }}
          tooltipText="adgroup.budgetAndDates.dateHelper"
          clearable={datesClearable}
          required={datesRequired}
          disableHoverEdition={isWizard}
          editable={canEdit}
        />
      </Grid>
    </FieldGroup>
  )
}
export default Dates
